module.exports = __webpack_public_path__ + "img/frame (186).a083e469.jpg";